import { useState, useEffect } from 'react';

/**
 * Hook para monitorar o tamanho da janela
 * Útil para implementações responsivas
 * 
 * @returns {Object} Objeto contendo largura e altura da janela
 */
export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // Função para atualizar estado
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    
    // Adicionar listener
    window.addEventListener('resize', handleResize);
    
    // Limpar listener quando o componente for desmontado
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
